import React, { CSSProperties, FC, ReactNode } from 'react'
import { RowProps } from 'antd'

import { TCssScrollerProps } from 'src/storybook/components'

import LayoutFormScrollable from './LayoutFormScrollable'
import { theme } from '../theme'

type TLayoutFormScrollableDividerProps = {
  scrollerClass?: string
  cssScroller?: TCssScrollerProps
  footer?: ReactNode
  rowProps?: RowProps
  footerContainerStyle?: CSSProperties
}

const LayoutFormScrollableDivider: FC<TLayoutFormScrollableDividerProps> = ({
  scrollerClass,
  cssScroller,
  footer,
  rowProps,
  children,
  footerContainerStyle,
}) => {
  return (
    <LayoutFormScrollable
      rowProps={{
        gutter: [0, 1],
        style: {
          backgroundColor: theme.colors.borderBg,
        },
        ...rowProps,
      }}
      cssScroller={cssScroller}
      scrollerClass={scrollerClass}
      footer={footer}
      footerContainerStyle={{
        borderTop: `1px solid ${theme.colors.borderBg}`,
        ...footerContainerStyle,
      }}
    >
      {children}
    </LayoutFormScrollable>
  )
}

export default LayoutFormScrollableDivider
